import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import GoogleMapReact from 'google-map-react'
import settings from "settings"
import _ from 'lodash'
import mapStyles from 'helpers/mapStyle'
import { getNavigator } from "actions"

const Marker = () => (
	<div className="navigator__marker"></div>
)

class Navigator extends Component {

	constructor(props) {
		super(props)
		this.state = {
			lat: '',
			lng: ''
		}
	}

	componentDidMount() {
		this.props.getNavigator()
	}

	getGeo() {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition((position) => {
				this.setState({
					lat: position.coords.latitude,
					lng: position.coords.longitude
				})
			}, function() {
				console.log('error')
			}, { enableHighAccuracy: true, maximumAge: 10 })
			navigator.geolocation.watchPosition((position) => {
				this.setState({
					lat: position.coords.latitude,
					lng: position.coords.longitude
				}, () => {
					console.log(this.state)
				})

			}, function() {
				console.log('error')
			}, { enableHighAccuracy: true, maximumAge: 10 })
		}
	}

	

	handleApiLoaded(map, maps) {
		var ib, marker
		if (_.isEmpty(this.props.navigator.allLots)) { return }
		map.data.setStyle(mapStyles)
		// Blank GEO
		this.props.navigator.allLots.geojson.features.forEach((r, i) => {
			var c = r.geometry.coordinates
			if (!c) {
				//console.log(r)
				this.props.navigator.allLots.geojson.features[i].geometry.coordinates = []
			}
		})
		map.data.addGeoJson(this.props.navigator.allLots.geojson)
		map.data.setStyle(function(feature) {

			var color = ''
			var fo = 0.6
			var entry_id = feature.getProperty('entry_id')
			var passed = feature.getProperty('Passed')
			var section = feature.getProperty('Section')
			var color = 'gray'
			var strokeColor = color
			var zIndex = 100
			var status = feature.getProperty('Status')
			// If sold, it's gray
			if (status == 'Sold') {
				color = 'gray'
				strokeColor = 'gray'
				zIndex = 1
			}
			if (status == 'Available Home') {
				color = 'orange'
				strokeColor = 'orange'
				zIndex = 1
			}
			if (feature.getProperty('SalePending')) {
				color = 'gray'
				strokeColor = 'gray'
				zIndex = 1
			}


			return ({
				fillColor: color,
				fillOpacity: fo,
				strokeColor: strokeColor,
				strokeWeight: 2,
				zIndex: zIndex
			})
		})

		map.data.addListener('click', (event) => {
			var lot = event.feature
			if (lot.getProperty('BuilderID')) {
				var [copy, addl, salePendingText] = ['', '', '']
				var source
				// Lot is setup
				var builderId = lot.getProperty('BuilderID')
				var builderName = this.props.navigator.builders[builderId]
				var address = lot.getProperty('Address')
				var status = lot.getProperty('Status')
				var salePending = lot.getProperty('SalePending')
				var lbs = lot.getProperty('url')
				console.log(lot)
			}
		})

		this.getGeo()
		new maps.Marker({
			position: new maps.LatLng(this.state.lat, this.state.lng),
			map: map,
			zIndex: 1
		})
		//marker.setPosition(pos)
	}

	render() {
		if (this.props.navigatorStatus) {
			return (
				<div className="navigator">
					<div className="navigator__drawer">
						<div className="navigator__logo"></div>
						<div className="navigator__menuCont"></div>
					</div>
					<GoogleMapReact
						bootstrapURLKeys={{
							key: settings.gmapsApiKey,
							libraries: 'visualization'
						}}
						defaultCenter={settings.execMapCenter}
						defaultZoom={15}
						onGoogleApiLoaded={({ map, maps }) => this.handleApiLoaded(map, maps)}
						yesIWantToUseGoogleMapApiInternals
					>
						<Marker
							lat={this.state.lat} 
							lng={this.state.lng}
						/>
					</GoogleMapReact>
				</div>
			)
		} else {
			return ('no')
		}
	}
}

function mapStateToProps(state) {
	return {
		navigator: state.navigator,
		navigatorStatus: state.navigatorStatus
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({
		getNavigator,
	}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Navigator)